import AuthService from 'common/auth.service';
import React from 'react';
import MediwatcherTaxonomyListing from './components/mediwatcherTaxonomy';
import SmkTaxonomyListing from './components/smkTaxonomyList';
import TpzTaxonomyListing from './components/tpzTaxonomyList';
import HealthcareTaxonomyListing from './components/healthcareTaxonomyList';

const TaxonomyListing = () => {
  const auth = new AuthService();
  const source = auth.getAppSourceCookie();

  return source === 'schoolmykids' ? (
    <SmkTaxonomyListing />
  ) : source === 'theparentz' ? (
    <TpzTaxonomyListing title="TPZ" />
  ) : source === 'mediwatcher' ? (
    <MediwatcherTaxonomyListing />
  ) : (
    <TpzTaxonomyListing />
  );
};

export default TaxonomyListing;
